import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, BookOpen } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <BookOpen className="h-8 w-8 text-sage-700" />
            <span className={`ml-2 text-xl font-serif font-semibold ${isScrolled ? 'text-sage-800' : 'text-white'}`}>
              Casa Leahu
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {['Home', 'Rooms', 'Book', 'Contact'].map((item) => (
              <Link
                key={item}
                to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                className={`
                  ${isScrolled ? 'text-gray-700 hover:text-sage-700' : 'text-white hover:text-sage-200'}
                  transition-colors font-medium
                `}
              >
                {item}
              </Link>
            ))}
            <Link
              to="/book"
              className="bg-sage-700 hover:bg-sage-800 text-white px-4 py-2 rounded-md transition-colors"
            >
              Rezerva acum
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            type="button"
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className={`h-6 w-6 ${isScrolled ? 'text-gray-800' : 'text-white'}`} />
            ) : (
              <Menu className={`h-6 w-6 ${isScrolled ? 'text-gray-800' : 'text-white'}`} />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 bg-white rounded-md shadow-lg">
            <div className="flex flex-col space-y-2 px-4 py-2">
              {['Home', 'Rooms', 'Book', 'Contact'].map((item) => (
                <Link
                  key={item}
                  to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                  className="text-gray-700 hover:text-sage-700 py-2 transition-colors"
                >
                  {item}
                </Link>
              ))}
              <Link
                to="/book"
                className="bg-sage-700 hover:bg-sage-800 text-white px-4 py-2 rounded-md transition-colors text-center mt-2"
              >
                Book Now
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Navbar;